var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256,508C116.824,508,4,395.176,4,256S116.824,4,256,4s252,112.824,252,252 C507.84,395.112,395.112,507.84,256,508z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M256,8c136.968,0,248,111.032,248,248S392.968,504,256,504S8,392.968,8,256 C8.152,119.096,119.096,8.152,256,8 M256,0C114.616,0,0,114.616,0,256s114.616,256,256,256s256-114.616,256-256S397.384,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M406.28,110.312v188c-0.016,13.352-10.84,24.176-24.192,24.192H105.712v-188 c0.016-13.352,10.84-24.176,24.192-24.192H406.28 M414.28,102.312H129.912c-17.776,0-32.192,14.416-32.192,32.192v196h284.368 c17.776,0,32.192-14.416,32.192-32.192C414.28,298.312,414.28,102.312,414.28,102.312z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 97.72,
    y: 139.008,
    width: 316.568,
    height: 45.608
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138.824,
    y: 220.056,
    style: {
      fill: "#999999"
    },
    width: 104.32,
    height: 14.472
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E21B1B"
    },
    points: "168,363.16 256,277.08 344,363.16 306.232,363.16 306.232,455.872 205.768,455.872  205.768,363.16 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.7198b1e07157bc69052ba0f4ce4b0e50.svg";
export { ForwardRef as ReactComponent };